import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";

export const getAdmins = createAsyncThunk(
  "admin/getAdmins",
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${BASE_URL}/user/admins`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return res.data;
    } catch (err) {
      console.log(err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка');
    }
  }
);

export const updateAdmin = createAsyncThunk(
  "admin/updateAdmin",
  async (formData, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      if (!(formData instanceof FormData)) {
        return thunkAPI.rejectWithValue('Некоректні дані форми');
      }

      const res = await axios.post(`${BASE_URL}/user/admin`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    } catch (err) {
      console.log(err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка');
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdmins.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAdmins.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getAdmins.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateAdmin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateAdmin.fulfilled, (state, action) => {
        state.isLoading = false;
        // Обновляем текущего пользователя в user slice
      })
      .addCase(updateAdmin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default adminSlice.reducer;

